import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { ConfirmProvider } from './hooks/useConfirm'
import './index.css'

/* Tijdelijk: stuur client-side crashes naar backend zodat we kunnen zien
   waarom OBS-scherm-viewers na render zwart worden. Post fire-and-forget,
   geen retry, geen dependency op axios (die kan zelf ook crashen). */
function stuurClientError(scope, ev) {
  try {
    const detail = ev?.error?.stack || ev?.reason?.stack || ev?.reason
                || ev?.message || String(ev)
    fetch('/api/client-error-log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        scope,
        url: location.href,
        pad: location.pathname,
        ua: navigator.userAgent,
        detail: String(detail).slice(0, 4000),
        ts: Date.now(),
      }),
    }).catch(() => {})
  } catch {}
}
window.addEventListener('error', (ev) => stuurClientError('error', ev))
window.addEventListener('unhandledrejection', (ev) => stuurClientError('promise', ev))

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
  </BrowserRouter>,
)
